module.exports = __webpack_public_path__ + "b36ff68d1b5adf2bf059314539ab3a91.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/public/verification/slack/slack-verification.html
// module id = 2028
// module chunks = 0